import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../atoms/buttons/enums.js';
import { isRTL } from '../../../utilities/dom-helpers/index.js';

/* eslint-disable import/no-absolute-path */
function renderLayout(ctx, options) {
    const { headlineColor, headlineSize } = options;
    return x `<div class="header"><slot name="headline" class="${headlineColor} ${headlineSize}"></slot><slot name="cta"></slot></div><div class="swiper"><div class="swiper-wrapper"></div><slot name="slide-container"></slot></div><carousel-navigation ?rtl="${ctx.rtl || isRTL() ? 'rtl' : ''}" nextText="${ctx.nextText}" previousText="${ctx.previousText}"></carousel-navigation>`;
}

export { renderLayout };
